export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "handling_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prise en charge"])},
        "handling_type_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
        "refunded_entity_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payeur"])},
        "handler_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionnaire"])},
        "store_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Point de vente"])},
        "declaration_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description de la déclaration"])},
        "items_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lignes du document"])},
        "total_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant total :"])},
        "quotation_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devis validé"])},
        "max_compensation_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant maximal de prise en charge"])}
      },
      "en": {
        "handling_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handling"])},
        "handling_type_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
        "refunded_entity_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payer"])},
        "handler_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim handler"])},
        "store_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales channel"])},
        "declaration_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Claim declaration description"])},
        "items_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Document line items"])},
        "total_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total amount:"])},
        "quotation_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approved quotation"])},
        "max_compensation_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maximum coverage amount"])}
      }
    }
  })
}
